import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { BehaviorSubject, finalize, Observable, timer } from 'rxjs';
import { SpinnerService } from '../../api/spinner.service';
import { SPINNER_IGNORE_KEY } from '../../constants/spinner-constants';

const displaySpinnerTimeout = 1500; // milliseconds

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
  private loadingRequests = 0;
  private loadingRequestsSubject = new BehaviorSubject<number>(0);

  constructor(private spinnerService: SpinnerService) {
    this.loadingRequestsSubject.asObservable().subscribe((requests) => {
      requests <= 0 && spinnerService.hide();
    });
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.headers.has(SPINNER_IGNORE_KEY)) {
      return next.handle(request);
    }

    const spinnerTimerSubscription = timer(displaySpinnerTimeout).subscribe(() => {
      this.loadingRequestsSubject.next(++this.loadingRequests);
      this.spinnerService.show();
    });

    return next.handle(request).pipe(
      finalize(() => {
        this.loadingRequestsSubject.next(--this.loadingRequests);
        spinnerTimerSubscription.unsubscribe();
      })
    );
  }
}
